import { useRef, useState, useEffect } from "react";
import styles from "../mainPage.module.css";
import "./todoForm.scss";
import "react-multi-date-picker/styles/layouts/prime.css";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import toast from "react-hot-toast";
const TodoForm = ({ allUserTag, addTodoHandler }) => {
  const [value, setValue] = useState("");
  const [valUserTag, setValUserTag] = useState("");
  const [price, setPrice] = useState();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const changeHandler = (e) => {
    setValue(e.target.value);
  };
  const changeHandlerJazebe = (option) => {
    if (option.__isNew__) {
      setValUserTag({ ...option, value: -1 });
    }
    setValUserTag(option);
    console.log("option", option);
    setPrice(option.default_price);
    setValue(option.default_need_time);
  };
  const changeHandlerPrice = (e) => {
    setPrice(e.target.value);
  };
  const animatedComponents = makeAnimated();
  function AnimatedMulti() {
    return (
      <CreatableSelect
        closeMenuOnSelect={true}
        components={animatedComponents}
        isMulti={false}
        options={allUserTag}
        value={valUserTag}
        onChange={changeHandlerJazebe}
        styles={{ width: "100% !important" }}
      />
    );
  }
  const submitHandler = (e) => {
    e.preventDefault();
    if (valUserTag.length == 0) {
      toast.error("نام آپشن   را وارد نمایید");
      return null;
    }
    addTodoHandler(value, price, valUserTag);
    setValue("");
    setPrice("");
    setValUserTag("");
  };

  return (
    <div className="todoform">
      <form
        className={styles.formTodos}
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <div
          className={styles.formInputx}
          styles={{ width: "100% !important" }}
        >
          {AnimatedMulti()}
        </div>

        <input
          type="number"
          onChange={changeHandlerPrice}
          value={price}
          ref={inputRef}
          className={styles.inputName}
          placeholder="(تومان) قیمت "
        />

        <input
          placeholder="  (دقیقه) زمان"
          type="number"
          onChange={changeHandler}
          value={value}
          ref={inputRef}
          className={styles.inputName}
        />
        <button
          type="button"
          className={styles.inputBtn}
          onClick={submitHandler}
        >
          +
        </button>
      </form>
    </div>
  );
};

export default TodoForm;
